import { render } from "./ResourceTableToolbar.vue?vue&type=template&id=5c9911b4"
import script from "./ResourceTableToolbar.vue?vue&type=script&lang=js"
export * from "./ResourceTableToolbar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ResourceTableToolbar.vue"]])

export default __exports__